module.exports = __webpack_public_path__ + "static/media/memory_shoot.734b6f4a.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/assets/game_icons/memory_shoot.png
// module id = 319
// module chunks = 0